import { ID, Url } from '../../utils/codecUtils';
import { splitPayloadSchema, splitResponseSchema } from './split.schema';

export type SplitPayload = {
  documents: [
    {
      pages: Array<{ page: Url; rotationDeg?: number }>;
      metadata?: unknown;
    },
  ];
};

export type SplitResponse = {
  results: Array<{ document: Url; annotation: Url }>;
};

export const split = (annotationId: ID, payload: SplitPayload) => {
  return {
    endpoint: `/annotations/${annotationId}/split`,
    method: 'POST',
    responseSchema: splitResponseSchema,
    payload,
    payloadSchema: splitPayloadSchema,
  } as const;
};
